import React from "react";
import Image from "next/image";

import searchIcon from "/public/images/searchIcon.svg";
import { useGlobalState } from "context/GlobalStateContext";

type SearchInputPropsType = {
  handleSearch: (item: any) => void; //exemple for this type : setCounter(counter++)
  searchQuery: string;
  placeHolder: string;
};

function SearchInput({ handleSearch, searchQuery, placeHolder }: SearchInputPropsType) {
  // this searchInput is used in affariyet page

  const { direction } = useGlobalState();
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleSearch(event.target.value);
  };
  return (
    <div className="w-full bg-white flex flex-row gap-2 lg:gap-3 items-center   border-4 border-backgroundGrey rounded-lg p-3">
      <Image src={searchIcon} alt={"search icon"} width={15} height={15} className="m-1" />
      <input
        type="text"
        value={searchQuery}
        onChange={handleInputChange}
        placeholder={placeHolder}
        className={`bg-transparent outline-none flex-1   ${direction === "ltr" ? "border-l-2" : "border-r-2"} border-backgroundGrey px-2 `}
      />
    </div>
  );
}

export default SearchInput;
